module.exports = __webpack_public_path__ + "static/media/ic-chevron-down-blue.89f4cf3f.svg";